<template>
  <div class="card" data-testid="card">
    <div class="card__content">
      <div v-if="!isMobile" class="card__icon">
        <Document class="logo"/>
      </div>
      <div class="card__details">
        <header class="card__title vc-ellipsis" v-if="this.item.title">
          <h2 class="vc-ellipsis" data-testid="card__title">{{item.title}}</h2>
        </header>
        <div class="detail detail--status" data-testid="detail--status">
          <div class="detail__icon">
            <VcIcon size="20"
                    :style="{ color: statusInfo.color }">
              {{statusInfo.icon}}
            </VcIcon>
          </div>
          <div class="detail__label detail__status"
               :style="{ color: statusInfo.color }"
               data-testid="status_label">
            {{$t(statusInfo.label)}}
          </div>
        </div>
        <div class="detail detail--member" data-testid="detail--member">
          <div class="detail__icon">
            <v-icon size="20" data-testid="status_icon">icon-Male</v-icon>
          </div>
          <div class="detail__label">
            <DisplayName :matter="matter"
                         :contact="contact"
                         :isMobile="isMobile"
                         :isClickable="true"
                         :showAvatar="false" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SkeletonText, DisplayName } from '@/modules/common/components';
import { statuses } from "../constants";
import getStatus from '../services/statusService';

export default {
  name: "DocuformCard",
  components: {
    SkeletonText,
    DisplayName,
    Document: () => import("@/assets/images/svg/icons-misc/Document.svg"),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    matter: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.statuses = statuses;
  },
  computed: {
    statusInfo() {
      return getStatus(this.item);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";
.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  height: inherit;
  padding-inline-start: 24px;
  padding-inline-end: 12px;

  @include md-and-up-main {
    padding: 0 20px;
  }

  &__content {
    display: flex;
    width: 100%;
  }

  &__icon {
    width: 80px;
    display: flex;
    justify-content: flex-start;
    margin-inline-end: 20px;
  }

  &__details {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 100%;

    @include md-and-up-main {
      max-width: none;
    }

    ::v-deep .display-name {

      &__contact{
        color: #616161;
        border-inline-end-color: $grey-color-15;
        font-weight: 400;
      }

      &__matter{
        color: #212121;
        font-weight: 400;
      }
    }

  }

  &__title {
    font-weight: 700;
    margin-bottom: 8px;
    line-height: 28px;

    h2 {
      color: inherit;
      font-weight: 700;
      margin: 0;
      font-size: 18px;

      @include md-and-up-main {
        font-size: 20px;
      }
    }
  }
  .detail {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    height: 20px;
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &__icon {
      margin-inline-end: 10px;
      height: inherit;
    }

    &__label {
      height: inherit;
      flex-grow: 1;
      font-weight: 600;
    }

    &__status {
      position: relative;
      top: 1px;
      text-transform: uppercase;
    }
  }
}
</style>
